module.exports = __webpack_public_path__ + "media/assets/faria_products/CTNext-ba1968e377d671b349c089072179ad9d8bd0cc118ff34ad2558db9fbfd159bd0.png";